import { useNavigate } from 'react-router-dom';
import cn from 'classnames';

import styles from './Row.module.sass';
import { IUserListItem } from '@types';
import { paths } from 'router/paths';
import Checkbox from '../../../../components/Checkbox';

interface RowProps {
  item: IUserListItem;
  isSelected?: boolean;
  onSelect?: (isSelected: boolean) => void;
}

const Row = ({ item, isSelected = false, onSelect }: RowProps) => {
  const navigate = useNavigate();

  const navigateToDetails = (id: string) => {
    navigate(paths.USER_DETAILS_PATH.replace(':id', id));
  };

  const handleCheckboxChange = (checked: boolean) => {
    if (onSelect) {
      onSelect(checked);
    }
  };

  const handleRowClick = (event: React.MouseEvent) => {
    // Don't navigate if clicking on checkbox
    if ((event.target as HTMLElement).closest('label')) {
      return;
    }
    navigateToDetails(item.id);
  };

  return (
    <>
      <div className={cn(styles.row)} onClick={handleRowClick}>
        <div className={styles.col}>
          {onSelect && (
            <Checkbox
              value={isSelected}
              onChange={handleCheckboxChange}
              className={styles.checkbox}
              classCheckboxTick=""
              content=""
              reverse={false}
            />
          )}
        </div>
        <div className={styles.col}>
          <div className={styles.item}>
            <div className={styles.avatar}>
              <img
                src={item.profilePhoto !== '' ? item.profilePhoto : '/images/content/avatar-2.jpg'}
                alt="Profile Photo"
              />
            </div>
            <div className={styles.details}>
              <div className={styles.user}>{`${item.firstName} ${item.lastName}`}</div>
              <div className={styles.city}>{item.city}</div>
              <div className={styles.email}>{item.email}</div>
            </div>
          </div>
        </div>

        <div className={styles.col}>
          <div className={styles.email}>{item.email}</div>
        </div>
        <div className={styles.col}>
          <div>{item.phoneNumber}</div>
        </div>
        <div className={styles.col}>
          <div className={cn(styles.status)}>{`${item.rank_name} (${item.score})`}</div>
        </div>
      </div>
    </>
  );
};

export default Row;
